import { Injectable, inject } from '@angular/core';
import {
  ActivitiesAssignment,
  Score,
  ShiftAssignment,
  UserTimelinesModal,
} from '@wilson/interfaces';
import { ShiftScoresService } from '@wilson/shift/core';

@Injectable({
  providedIn: 'root',
})
export class FindStaffPopupHelperService {
  private shiftScoresService = inject(ShiftScoresService);

  sortStaffSearchResults(
    users: (UserTimelinesModal & {
      shiftAssignment: ShiftAssignment | ActivitiesAssignment | undefined;
    })[],
  ) {
    const clonedUsers = [...users];

    clonedUsers.sort((a, b) => {
      const qualificationFulfilledA =
        !a.shiftAssignment?.shiftValidationErrors.length ||
        a.shiftAssignment?.shiftValidationErrors.every(
          (qualification) => qualification.valid,
        );
      const qualificationFulfilledB =
        !b.shiftAssignment?.shiftValidationErrors.length ||
        b.shiftAssignment?.shiftValidationErrors.every(
          (qualification) => qualification.valid,
        );
      let smartScoresA: Score[] = [];
      let smartScoresB: Score[] = [];
      if (a.shiftAssignment && b.shiftAssignment) {
        smartScoresA = a.shiftAssignment.scores.filter(
          (res) => res.name === 'shift-smart-score',
        );
        smartScoresB = b.shiftAssignment.scores.filter(
          (res) => res.name === 'shift-smart-score',
        );
      }
      const smartScoreA =
        this.shiftScoresService.calculateSmartScore(smartScoresA);
      const smartScoreB =
        this.shiftScoresService.calculateSmartScore(smartScoresB);

      let prefScoresA: Score[] = [];
      let prefScoresB: Score[] = [];
      if (a.shiftAssignment && b.shiftAssignment) {
        prefScoresA = a.shiftAssignment.scores.filter(
          (res) => res.name === 'shift-preference-score',
        );
        prefScoresB = b.shiftAssignment.scores.filter(
          (res) => res.name === 'shift-preference-score',
        );
      }
      const prefScoreA =
        this.shiftScoresService.calculatePrefScore(prefScoresA);
      const prefScoreB =
        this.shiftScoresService.calculatePrefScore(prefScoresB);

      if (smartScoreA !== smartScoreB) {
        return Number(smartScoreB) - Number(smartScoreA); // Descending order
      }

      if (prefScoreA !== prefScoreB) {
        return Number(prefScoreB) - Number(prefScoreA); // Descending order
      }

      return Number(qualificationFulfilledB) - Number(qualificationFulfilledA);
    });
    return clonedUsers;
  }
}
